import { dataFilter } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFilter = /*#__PURE__*/createIcon(dataFilter)
export default IconFilter
